import React from 'react';

import { logger as LOG } from '@garnish/logger';

import { useEssentialMachines } from '../../EssentialMachines';

// ────────────────────────────────────────────────────────────────────────────────
const logger = LOG.extend('AUTH');
// ────────────────────────────────────────────────────────────────────────────────

export const useSendLoginToAuthMachine = () => {
  const { authMachineRef } = useEssentialMachines();

  const sendLoginAction = React.useCallback(
    (params?: SendLoginActionParams) => {
      logger.debug('sending LOGIN event to AuthMachine');
      authMachineRef.send({
        type: 'LOGIN',
        csrfToken: params?.csrf,
        postLoginRedirectHref: params?.postLoginRedirectHref,
      });
    },
    [authMachineRef],
  );

  return sendLoginAction;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type SendLoginActionParams = {
  csrf?: string;
  postLoginRedirectHref?: string;
};
